import React, { Component } from "react";
import Header from "./Header";
import App from "..//App";


export default class Home extends Component {
  render() {
    return (
      <>
        <Header />
        <App />
      </>
    );
  }
}
